<template>
  <v-container>
    <img src="../assets/breadcrumb1.svg" />

    <h2 class="headline my-2">Incorporate Your Business In Three Easy Steps</h2>
    <h3 class="subtitle">
      You can incorporate your business in 10 minutes or less. Plus, each package is backed by our
      100% Money Back Guarantee
    </h3>
    <v-form ref="form">
      <v-layout wrap>
        <v-flex xs12 sm6 mx-1>
          <v-select
            v-model="type"
            :items="types"
            :rules="[required]"
            label="Business Types"
            data-cy="type"
          />
        </v-flex>
        <v-flex mx-1>
          <v-autocomplete
            v-model="state"
            :items="states"
            :rules="[required]"
            label="State"
            browser-autocomplete="address-level1"
            class="mx-1"
            data-cy="state"
          />
        </v-flex>
      </v-layout>

      <h1 class="title">Select a Package</h1>
      <v-layout justify-space-around>
        <v-flex class="mx-1 max-width"> <img src="../assets/BASIC4.svg" /> </v-flex>
        <v-flex class="mx-1 max-width"> <img src="../assets/STANDARD4.svg" /> </v-flex>
        <v-flex class="mx-1 max-width"> <img src="../assets/PREMIUM4.svg" /> </v-flex>
      </v-layout>

      <v-layout justify-space-around>
        <v-btn
          v-for="(name, index) in packages"
          :key="index"
          :color="packageColor(name)"
          @click="setPackage(name);"
        >
          {{ name }}
        </v-btn>
      </v-layout>
      <v-alert :value="isPackageError" type="error"> You must choose a package </v-alert>

      <v-btn block color="success" @click="done">Continue</v-btn>
    </v-form>

    <v-expansion-panel>
      <v-expansion-panel-content>
        <div slot="header">Verify Company Name Availability</div>
        <v-card>
          <v-card-text>
            Before we sumbit your paperwork to the state, we will verify that your chosen business
            name is available. If your business name is unavailable, we will promptly contact you
            for alternate names.
          </v-card-text>
        </v-card>
      </v-expansion-panel-content>
    </v-expansion-panel>
    <v-expansion-panel>
      <v-expansion-panel-content>
        <div slot="header">Preparation of Articles of Organization</div>
        <v-card>
          <v-card-text>
            Following a thorough review of the information you provide, we will create and complete
            all the necessary paperwork to incorporate your business.
          </v-card-text>
        </v-card>
      </v-expansion-panel-content>
    </v-expansion-panel>
    <v-expansion-panel>
      <v-expansion-panel-content>
        <div slot="header">Document of Filing with Secretary of State</div>
        <v-card>
          <v-card-text>
            Lorem ipsum dolor sit amet, consectetur adipisci quis consequat.
          </v-card-text>
        </v-card>
      </v-expansion-panel-content>
    </v-expansion-panel>
    <v-expansion-panel>
      <v-expansion-panel-content>
        <div slot="header">Federal Tax ID</div>
        <v-card>
          <v-card-text>
            Lorem ipsum dolor sit amet, consectetur adipisci quis consequat.
          </v-card-text>
        </v-card>
      </v-expansion-panel-content>
    </v-expansion-panel>
    <v-expansion-panel>
      <v-expansion-panel-content>
        <div slot="header">Registered Agent Service</div>
        <v-card>
          <v-card-text>
            Lorem ipsum dolor sit amet, consectetur adipisci quis consequat.
          </v-card-text>
        </v-card>
      </v-expansion-panel-content>
    </v-expansion-panel>
    <v-expansion-panel>
      <v-expansion-panel-content>
        <div slot="header">Deluxe Corporate Kit</div>
        <v-card>
          <v-card-text>
            Lorem ipsum dolor sit amet, consectetur adipisci quis consequat.
          </v-card-text>
        </v-card>
      </v-expansion-panel-content>
    </v-expansion-panel>
  </v-container>
</template>

<script>
import { pick } from 'lodash-es';
import { states } from './util';

export default {
  data: () => ({
    states,
    type: '',
    types: [
      { text: 'LLC', value: 'llc' },
      { text: 'S Corp', value: 'scorp' },
      { text: 'C Corp', value: 'ccorp' },
      { text: 'Nonprofit', value: 'nonprofit' },
    ],
    state: '',
    packageName: '',
    packages: ['basic', 'primary', 'premium'],
    isPackageError: false,
  }),
  mounted() {
    this.$store.dispatch('setToken');
    this.type = this.$route.query.type;
  },
  methods: {
    async done() {
      if (!this.packageName) this.isPackageError = true;
      if (!this.$refs.form.validate() || this.isPackageError) return;
      await this.$store.dispatch('choose', pick(this.$data, ['type', 'state', 'packageName']));
      await this.$store.dispatch('recalculatePrice');
      this.$router.push({ path: 'stage2' });
    },
    required: field => !!field || 'This field is required',
    packageColor(name) {
      if (this.isPackageError) return 'error';
      return this.packageName === name ? 'info' : '';
    },
    setPackage(name) {
      this.isPackageError = false;
      this.packageName = name;
    },
  },
};
</script>

<style>
.max-width {
  max-width: 350px;
}
</style>
